import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

export interface DialogData {
  title: string;
  message: string;
  confirmText?: string;
  cancelText?: string;
  type?: string;
  resolve?: (value: any) => void;   // ✅ changed
}

@Injectable({
  providedIn: 'root'
})
export class DialogService {
  private dialogSubject = new Subject<DialogData | null>();
  dialogState$ = this.dialogSubject.asObservable();

  confirm(title: string, message: string, confirmText: string = 'Confirm', cancelText: string = 'Cancel', type: string = 'warning'): Promise<any> {  // ✅ changed
    return new Promise((resolve) => {
      this.dialogSubject.next({
        title,
        message,
        confirmText,
        cancelText,
        type,
        resolve
      });
    });
  }

  close(result: boolean, data: DialogData, extraData?: any): void {   // ✅ changed
    if (data.resolve) {
      data.resolve({
        confirmed: result,
        ...extraData
      });
    }
    this.dialogSubject.next(null);
  }
}
